// Single source of truth for all route configuration
export const ROUTE_CONFIG = {
  HOME: {
    path: '/',
    requiresAuth: false,
    sitemap: {
      include: true,
      priority: 1.0,
      changefreq: 'daily',
    },
  },
  LOGIN: {
    path: '/login',
    requiresAuth: false,
    sitemap: {
      include: true,
      priority: 0.6,
      changefreq: 'monthly',
    },
  },
  REGISTER: {
    path: '/register',
    requiresAuth: false,
    sitemap: {
      include: true,
      priority: 0.6,
      changefreq: 'monthly',
    },
  },
  COMPLETE_PROFILE: {
    path: '/complete-profile',
    requiresAuth: false,
    sitemap: {
      include: false, // Internal flow
    },
  },
  AUTH_CALLBACK: {
    path: '/auth/callback',
    requiresAuth: false,
    sitemap: {
      include: false, // OAuth callback
    },
  },
  PRIVACY_POLICY: {
    path: '/privacy-policy',
    requiresAuth: false,
    sitemap: {
      include: true,
      priority: 0.5,
      changefreq: 'yearly',
    },
  },
  TERMS_OF_SERVICE: {
    path: '/terms-of-service',
    requiresAuth: false,
    sitemap: {
      include: true,
      priority: 0.5,
      changefreq: 'yearly',
    },
  },
  ABOUT: {
    path: '/about',
    requiresAuth: false,
    sitemap: {
      include: true,
      priority: 0.8,
      changefreq: 'weekly',
    },
  },
  HELP: {
    path: '/help',
    requiresAuth: false,
    sitemap: {
      include: true,
      priority: 0.7,
      changefreq: 'weekly',
    },
  },
  SETTINGS: {
    path: '/settings',
    requiresAuth: false, // Optional auth handled by OptionalAuthRoute
    sitemap: {
      include: true,
      priority: 0.6,
      changefreq: 'monthly',
    },
  },
  CONTACT: {
    path: '/contact',
    requiresAuth: false,
    sitemap: {
      include: true,
      priority: 0.7,
      changefreq: 'monthly',
    },
  },
}

// Export simple ROUTES object for backward compatibility
export const ROUTES = Object.entries(ROUTE_CONFIG).reduce((acc, [key, config]) => {
  acc[key] = config.path
  return acc
}, {})
